var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "style-edit-container" },
    [
      _c(
        _setup.Collapse,
        {
          scopedSlots: _vm._u([
            {
              key: "header",
              fn: function () {
                return [
                  _vm._v(
                    " " +
                      _vm._s(_vm.trans("map.style-control.layer.title")) +
                      " "
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c("div", { staticClass: "label-config-container" }, [
            _c("div", { staticClass: "label-config-item" }, [
              _c("div", { staticClass: "label-config-item__label" }, [
                _vm._v(
                  " " + _vm._s(_vm.trans("map.style-control.layer.id")) + " "
                ),
              ]),
              _c("div", { staticClass: "label-config-item__input" }, [
                _vm._v(" " + _vm._s(_setup.layer.id)),
              ]),
            ]),
            _c("div", { staticClass: "label-config-item" }, [
              _c("div", { staticClass: "label-config-item__label" }, [
                _vm._v(
                  " " + _vm._s(_vm.trans("map.style-control.layer.type")) + " "
                ),
              ]),
              _c("div", { staticClass: "label-config-item__input" }, [
                _vm._v(" " + _vm._s(_setup.layer.type)),
              ]),
            ]),
            _c("div", { staticClass: "label-config-item" }, [
              _c("div", { staticClass: "label-config-item__label" }, [
                _vm._v(
                  " " +
                    _vm._s(_vm.trans("map.style-control.layer.min-zoom")) +
                    " "
                ),
              ]),
              _c(
                "div",
                { staticClass: "label-config-item__input" },
                [
                  _c(_setup.inputSlider, {
                    attrs: {
                      value:
                        _setup.layer["min-zoom"] != null
                          ? _setup.layer["min-zoom"]
                          : 0,
                      min: "0",
                      max: "24",
                      step: "1",
                    },
                    on: {
                      input: function ($event) {
                        return _setup.onChangeMinZoom($event, _setup.layer)
                      },
                    },
                  }),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "label-config-item" }, [
              _c("div", { staticClass: "label-config-item__label" }, [
                _vm._v(
                  " " +
                    _vm._s(_vm.trans("map.style-control.layer.max-zoom")) +
                    " "
                ),
              ]),
              _c(
                "div",
                { staticClass: "label-config-item__input" },
                [
                  _c(_setup.inputSlider, {
                    attrs: {
                      value:
                        _setup.layer["max-zoom"] != null
                          ? _setup.layer["max-zoom"]
                          : 24,
                      min: "0",
                      max: "24",
                      step: "1",
                    },
                    on: {
                      input: function ($event) {
                        return _setup.onChangeMaxZoom($event, _setup.layer)
                      },
                    },
                  }),
                ],
                1
              ),
            ]),
          ]),
        ]
      ),
      _c(
        _setup.Collapse,
        {
          scopedSlots: _vm._u([
            {
              key: "header",
              fn: function () {
                return [
                  _vm._v(
                    " " +
                      _vm._s(_vm.trans("map.style-control.style.title")) +
                      " "
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _setup.tabs_format && _setup.tabs_format.length > 1
            ? _c(
                "div",
                { staticClass: "tab-group-label" },
                _vm._l(_setup.tabs_format, function (item) {
                  return _c(
                    "div",
                    {
                      key: item.key,
                      staticClass: "tab clickable",
                      class: {
                        "tab-active":
                          _setup.tab_group &&
                          _setup.tab_group.trans == item.trans,
                      },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _setup.onSelectTabGroup(item)
                        },
                      },
                    },
                    [
                      _vm._v(
                        " " + _vm._s(item.text || _vm.trans(item.trans)) + " "
                      ),
                    ]
                  )
                }),
                0
              )
            : _vm._e(),
          _c("div", { staticClass: "tab-group-container" }, [
            _c("div", { staticClass: "label-container" }, [
              _setup.tab_group
                ? _c(
                    "div",
                    _vm._l(_setup.tab_group.items, function (item) {
                      return _c(
                        "div",
                        {
                          key: item.key,
                          staticClass: "clickable",
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _setup.onSelectTab(item)
                            },
                          },
                        },
                        [
                          item.type === "divider"
                            ? _c("div", { staticClass: "tab-divider" })
                            : _c(_setup.TabItem, {
                                attrs: {
                                  value:
                                    _setup.layer[item.part || "paint"][
                                      item.key
                                    ],
                                  item: item,
                                  text: item.text || _vm.trans(item.trans),
                                  default_value:
                                    _setup.default_value[item.part || "paint"][
                                      item.key
                                    ],
                                  active:
                                    _setup.tab && _setup.tab.key === item.key,
                                },
                              }),
                        ],
                        1
                      )
                    }),
                    0
                  )
                : _vm._e(),
            ]),
            _c("div", { staticClass: "value-container" }, [
              _c(
                "div",
                [
                  _setup.tab
                    ? _c("div", { staticClass: "value-container__label" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _setup.tab.text || _vm.trans(_setup.tab.trans)
                            ) +
                            " "
                        ),
                      ])
                    : _vm._e(),
                  _setup.tab
                    ? _c(_setup.TabContent, {
                        attrs: {
                          item: _setup.tab,
                          value:
                            _setup.layer[_setup.tab.part || "paint"][
                              _setup.tab.key
                            ],
                          default_value:
                            _setup.default_value[_setup.tab.part || "paint"][
                              _setup.tab.key
                            ],
                          trans: _vm.trans,
                          mapId: _vm.mapId,
                        },
                        on: {
                          input: function ($event) {
                            return _setup.emitInput(
                              $event,
                              _setup.tab,
                              _setup.layer
                            )
                          },
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }